import { useElementSize } from '~/scripts/composables/useElementSize'
import { defineComponent } from '~/scripts/utils/alpine'

export default defineComponent(() => ({
  init() {
    const { topbar, navbar } = this.$refs

    if (topbar) {
      useElementSize(topbar, ({ height }) => {
        this.$store.ui.setTopbarHeight(height)
      })
    }

    if (navbar) {
      useElementSize(navbar, ({ height }) => {
        this.$store.ui.setNavbarHeight(height)
        this.updateMenuOffsetTop(navbar)
      })
    }
  },
  updateMenuOffsetTop(navbar: HTMLElement) {
    const { bottom } = navbar.getBoundingClientRect()
    this.$store.ui.setMenuOffsetTop(bottom)
  },
}))
